import React from 'react';

import { makeStyles } from '@material-ui/styles';

const stripsStyles = makeStyles({
  root: {
    position: 'relative',
    height: '4px',
    background:
      'linear-gradient(to right, #fcd000 0, #ff8a00 17%, #ff253a 34%, #ff37a8 51%, #a400e1 67%, #0086ff 83%, #00d604 100%)',
  },
});

export default function Strips() {
  const classes = stripsStyles();

  return <div className={classes.root} />;
}
